var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h1',[_vm._v(_vm._s(_vm.animal.name)+" ("+_vm._s(_vm.$route.params.species)+")")]),_c('p',[_vm._v("Age: "+_vm._s(_vm.animal.age)+" years old")]),_c('p',[_vm._v("Breed: "+_vm._s(_vm.animal.breed))])])}
var staticRenderFns = []

export { render, staticRenderFns }